<template>
  <li class="item">
    <div class="prize-box sm">
      <span class="n-open" v-if="state.matches('failure')">点击开启</span>
      <div class="prize-img-bg" :class="{'wobble':state.matches('pending')}" >
        <!-- 不带背景的宝箱添加 prize-img-size  -->
        <img :src="state.context.award.url" v-if="state.matches('success')" />
        <img v-else-if="state.matches('failure')" @click="send('RETRY')" class="prize-img-size" src="../../../../ui/20201111king_double_eleven/assets/green-box-lg.png">
        <img v-else class="prize-img-size" src="../../../../ui/20201111king_double_eleven/assets/green-box-lg.png">
      </div>
    </div>
    <span class="prize-index">宝箱{{rank}}</span>
    <p class="name" v-show="state.matches('success')">{{state.context.award.name}}</p>
<!--    <button v-show="state.matches('failure')" @click="send('RETRY')">重试</button>-->
  </li>
</template>

<script>
import { useService } from "@xstate/vue"
export default {
  name: "AwardListItem",
  props: ["service", "rank"],
  setup(props) {
    const { state, send } = useService(props.service)
    return {
      state,
      send
    }
  }
}
</script>

<style scoped>
</style>
